import React, {useState} from 'react'
import ContactSupportTwoToneIcon from '@material-ui/icons/ContactSupportTwoTone';
import AssessmentTwoToneIcon from '@material-ui/icons/AssessmentTwoTone';
import ReceiptTwoToneIcon from '@material-ui/icons/ReceiptTwoTone';
import ScheduleTwoToneIcon from '@material-ui/icons/ScheduleTwoTone';
import SchoolTwoToneIcon from '@material-ui/icons/SchoolTwoTone';
import TrendingDownTwoToneIcon from '@material-ui/icons/TrendingDownTwoTone';
import AssignmentTwoToneIcon from '@material-ui/icons/AssignmentTwoTone';
import EventAvailableTwoToneIcon from '@material-ui/icons/EventAvailableTwoTone';
import HourglassFullTwoToneIcon from '@material-ui/icons/HourglassFullTwoTone';
import DateRangeTwoToneIcon from '@material-ui/icons/DateRangeTwoTone';
import LocalBarTwoToneIcon from '@material-ui/icons/LocalBarTwoTone';
import ContactPhoneTwoToneIcon from '@material-ui/icons/ContactPhoneTwoTone';
import { Form } from '../components/Form';

export function LandingPage() {
  const [annual, setAnnual] = useState(false)
  const changePrice = (e) => {
    e.target.checked ? setAnnual(true) : setAnnual(false)
  }
    return (
      <>
        {/* <!-- WELCOME --> */}
        <section className="py-10 py-md-14 bg-primary" id="welcome">
    
        {/* <!-- Shape --> */}
        <div className="shape shape-blur-3 text-white">
            <svg viewBox="0 0 1738 487" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h1420.92s713.43 457.505 0 485.868C707.502 514.231 0 0 0 0z" fill="url(#paint0_linear)"/><defs><linearGradient id="paint0_linear" x1="0" y1="0" x2="1049.98" y2="912.68" gradientUnits="userSpaceOnUse"><stop stopColor="currentColor" stopOpacity=".075"/><stop offset="1" stopColor="currentColor" stopOpacity="0"/></linearGradient></defs></svg>      </div>
    
        {/* <!-- Content --> */}
        <div className="container">
            <div className="row justify-content-center">
            <div className="col-12 col-md-10 col-lg-8 text-center">
    
                {/* <!-- Heading --> */}
                <h1 className="display-2 fw-bold text-white">
                Business in a Box.
                </h1>
    
                {/* <!-- Text --> */}
                <p className="lead text-white mb-8">
                Forward-thinking businesses use SingleLogin to <b>Secure</b> and <b>Centralize Technology Solutions</b> all in one place.
                </p>
    
                {/* <!-- Button --> */}
                <a href="/#demo" data-scroll='{"offset": 0}' className="btn btn-white shadow lift">
                Create a Business Account
                </a>
    
            </div>
            </div> {/* <!-- / .row --> */}
        </div> {/* <!-- / .container --> */}
    
        </section>
    
        {/* <!-- SHAPE --> */}
        <div className="position-relative">
        <div className="shape shape-bottom shape-fluid-x text-white">
            <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z" fill="currentColor"/></svg>      </div>
        </div>
    
        {/* <!-- ABOUT --> */}
        <section className="pt-8 pt-md-10" id="about">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
    
                {/* <!-- Button --> */}
                <a href="#about" className="btn btn-white btn-rounded-circle shadow mt-n12 mt-md-n14" data-scroll>
                  <i className="fe fe-arrow-down"></i>
                </a>
    
              </div>
            </div> {/* <!-- / .row --> */}
            <div className="row justify-content-center">
              <div className="col-12 col-md-10 col-lg-8 text-center">
    
                {/* <!-- Heading --> */}
                <h2 className="fw-bold">
                  Converge your <span className="text-primary">Business Applications</span>.
                </h2>
    
                {/* <!-- Text --> */}
                <p className="fs-lg text-muted mb-9">
                  SingleLogin lets you work seamlessly in a streamlined manner so that you can get work done efficiently and securely.
                </p>
    
              </div>
            </div> {/* <!-- / .row --> */}
            <div className="row">
              <div className="col-12 col-lg-6">
    
                {/* <!-- Item --> */}
                <div className="row align-items-center mb-8" data-aos="fade-up">
                  <div className="col-4 col-lg-5">
    
                    {/* <!-- Image --> */}
                    <img src="assets/img/illustrations/illustration-9.png" alt="..." className="img-fluid" />
    
                  </div>
                  <div className="col-8 col-lg-7">
    
                    {/* <!-- Heading --> */}
                    <h3 className="fw-bold mb-2">
                      Storage
                    </h3>
    
                    {/* <!-- Text --> */}
                    <p className="text-gray-700 mb-0">
                      Keep all your business data organized and accessible in one safe place and back up your most important information and data with one click. 
                    </p>
    
                  </div>
                </div> {/* <!-- / .row --> */}
    
                {/* <!-- Item --> */}
                <div className="row align-items-center mb-8" data-aos="fade-up">
                  <div className="col-4 col-lg-5">
    
                    {/* <!-- Image --> */}
                    <img src="assets/img/illustrations/illustration-8.png" alt="..." className="img-fluid" />
    
                  </div>
                  <div className="col-8 col-lg-7">
    
                    {/* <!-- Heading --> */}
                    <h3 className="fw-bold mb-2">
                      Collaboration
                    </h3>
    
                    {/* <!-- Text --> */}
                    <p className="text-gray-700 mb-0">
                      Accelerate productivity with microtechnology solutions and tools that are connected and accessible to all employees working within your organization.
                    </p>
    
                  </div>
                </div> {/* <!-- / .row --> */}
    
    
              </div>
              <div className="col-12 col-lg-6">
                {/* <!-- Item --> */}
                <div className="row align-items-center mb-8" data-aos="fade-up">
                  <div className="col-4 col-lg-5">
    
                    {/* <!-- Image --> */}
                    <img src="assets/img/illustrations/illustration-7.png" alt="..." className="img-fluid" />
    
                  </div>
                  <div className="col-8 col-lg-7">
    
                    {/* <!-- Heading --> */}
                    <h3 className="fw-bold mb-2">
                      Analytics
                    </h3>
    
                    {/* <!-- Text --> */}
                    <p className="text-gray-700 mb-0">
                      See what's happening in your company from a centralized dashboard. Remove all your business productivity dependencies. 
                    </p>
    
                  </div>
                </div> {/* <!-- / .row --> */}
    
                {/* <!-- Item --> */}
                <div className="row align-items-center mb-8" data-aos="fade-up">
                  <div className="col-4 col-lg-5">
    
                    {/* <!-- Image --> */}
                    <img src="assets/img/illustrations/illustration-6.png" alt="..." className="img-fluid" />
    
                  </div>
                  <div className="col-8 col-lg-7">
    
                    {/* <!-- Heading --> */}
                    <h3 className="fw-bold mb-2">
                      Permissions
                    </h3>
    
                    {/* <!-- Text --> */}
                    <p className="text-gray-700 mb-0">
                      Control who has access to which applications and data through our user management configuration tool and disable user access in real time whenever the need arises.
                    </p>
    
                  </div>
                </div> {/* <!-- / .row --> */}
    
              </div>
            </div> {/* <!-- / .row --> */}
          </div> {/* <!-- / .container --> */}
        </section>
    
        {/* <!-- UNIFIED --> */}
        <section className="pt-8 pt-md-11">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-12 col-md-6 col-lg-5" data-aos="fade-up">
    
                {/* <!-- Badge --> */}
                <span className="badge rounded-pill bg-primary-soft mb-3">
                  <span className="h6 text-uppercase">Centralized</span>
                </span>
    
                {/* <!-- Heading --> */}
                <h2 className="fw-bold">
                  Replace your microsolutions <br />
                  <span className="text-primary">with one simple app</span>.
                </h2>
    
                {/* <!-- Text --> */}
                <p className="fs-lg text-gray-700">
                  Using our framework and design pattern you can build and manage decentralized micro technology solutions without the need to develop complex Role-Based Access Control for authentication and authorization modules.
                </p>
    
                {/* <!-- Form --> */}
                <form className="mb-8">
                  <div className="row gx-4">
                    <div className="col-12 col-md">
    
                      {/* <!-- Input --> */}
                      <div className="form-group mb-md-0">
                        <input type="url" className="form-control bg-light border-0" placeholder="ceo@yourbusiness.com" />
                      </div>
    
                    </div>
                    <div className="col-12 col-md-auto">
    
                      {/* <!-- Submit --> */}
                      <button className="btn btn-primary-soft">
                        Get started
                      </button>
    
                    </div>
                  </div>
                </form>
    
              </div>
              <div className="col-12 col-md-6 col-lg-6 offset-lg-1">
    
                {/* <!-- Card --> */}
                <div className="card card-border border-primary shadow-lg mb-5" data-aos="fade-up">
                  <div className="card-body">
    
                    {/* <!-- List group --> */}
                    <div className="list-group list-group-flush">
                      <div className="list-group-item d-flex align-items-center">
    
                        {/* <!-- Text --> */}
                        <div className="me-auto">
    
                          {/* <!-- Heading --> */}
                          <p className="fw-bold mb-1">
                            One licence. All Standard Applications.
                          </p>
    
                          {/* <!-- Text --> */}
                          <p className="fs-sm text-muted mb-0">
                            We don't charge for the space you use up on our database or server; we simply charge for User Licence.
                          </p>
    
                        </div>
    
                        {/* <!-- Check --> */}
                        <div className="badge badge-rounded-circle bg-primary-soft ms-4">
                          <i className="fe fe-check"></i>
                        </div>
    
                      </div>
                      <div className="list-group-item d-flex align-items-center">
    
                        {/* <!-- Text --> */}
                        <div className="me-auto">
    
                          {/* <!-- Heading --> */}
                          <p className="fw-bold mb-1">
                            Guaranteed Uptime – Every time.
                          </p>
    
                          {/* <!-- Text --> */}
                          <p className="fs-sm text-muted mb-0">
                            Our platform is built on serverless technology with 99% reliable and guaranteed uptime. 
                          </p>
    
                        </div>
    
                        {/* <!-- Check --> */}
                        <div className="badge badge-rounded-circle bg-primary-soft ms-4">
                          <i className="fe fe-check"></i>
                        </div>
    
                      </div>
                      <div className="list-group-item d-flex align-items-center">
    
                        {/* <!-- Text --> */}
                        <div className="me-auto">
    
                          {/* <!-- Heading --> */}
                          <p className="fw-bold mb-1">
                            Lifetime storage *
                          </p>
    
                          {/* <!-- Text --> */}
                          <p className="fs-sm text-muted mb-0">
                            We store all your data permanently in the cloud for as long as your subscription remains active.
                          </p>
    
                        </div>
    
                        {/* <!-- Check --> */}
                        <div className="badge badge-rounded-circle bg-primary-soft ms-4">
                          <i className="fe fe-check"></i>
                        </div>
    
                      </div>
                      <div className="list-group-item d-flex align-items-center">
    
                        {/* <!-- Text --> */}
                        <div className="me-auto">
    
                          {/* <!-- Heading --> */}
                          <p className="fw-bold mb-1">
                            Minimal Design Meets Loaded Functionality
                          </p>
    
                          {/* <!-- Text --> */}
                          <p className="fs-sm text-muted mb-0">
                            Our app is super simple to use, easy to navigate, and outfitted with functionalities that optimizes individual and corporate productivity.
                          </p>
    
                        </div>
    
                        {/* <!-- Check --> */}
                        <div className="badge badge-rounded-circle bg-primary-soft ms-4">
                          <i className="fe fe-check"></i>
                        </div>
    
                      </div>
                    </div>
    
                  </div>
                </div>
    
                {/* <!-- Text --> */}
                <p className="fs-sm text-center text-gray-500 mb-0">
                  * Limited to the life of the Active Business
                </p>
    
              </div>
            </div> {/* <!-- / .row --> */}
          </div> {/* <!-- / .container --> */}
        </section>
    
        {/* <!-- INTEGRATIONS --> */}
        <section className="pt-8 pt-md-11" id="solutions">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 col-md-10 col-lg-8 text-center">
    
                {/* <!-- Badge --> */}
                <span className="badge rounded-pill bg-primary-soft mb-3">
                  <span className="h6 text-uppercase">Applications</span>
                </span>
    
                {/* <!-- Heading --> */}
                <h2 className="fw-bold">
                  Focus on Business. Let's handle the Technology!
                </h2>
    
                {/* <!-- Text --> */}
                <p className="fs-lg text-gray-700 mb-9">
                  Accelerate productivity with digital tools that are available and accessible to all employees working within your organization.
                </p>
    
              </div>
            </div> {/* <!-- / .row --> */}
            <div className="row">
              <div className="col-12 col-md-6 col-lg-4 text-center" data-aos="fade-up">
    
                {/* <!-- Icon --> */}
                <div className="icon icon-lg mb-4"><ContactSupportTwoToneIcon />            </div>
    
                {/* <!-- Heading --> */}
                <h3 className="fw-bold">
                  Support Tickets
                </h3>
    
                {/* <!-- Text --> */}
                <p className="text-muted mb-8">
                  View and resolve cases faster. Reduce resolution wait time for your customers and employees. Manage service level agreements with ease.
                </p>
    
              </div>
              <div className="col-12 col-md-6 col-lg-4 text-center" data-aos="fade-up">
    
                {/* <!-- Icon --> */}
                <div className="icon icon-lg mb-4">
                  <TrendingDownTwoToneIcon />
                </div>
    
                {/* <!-- Heading --> */}
                <h3 className="fw-bold">
                  Expense Tracking
                </h3>
    
                {/* <!-- Text --> */}
                <p className="text-muted mb-8 mb-lg-0">
                  See what you’re spending on and track every revenue you make using reports and charts that break down your cash flow and expenses in real-time.
                </p>
    
              </div>
              <div className="col-12 col-md-6 col-lg-4 text-center" data-aos="fade-up">
    
                {/* <!-- Icon --> */}
                <div className="icon icon-lg mb-4"><ReceiptTwoToneIcon /></div>
    
                {/* <!-- Heading --> */}
                <h3 className="fw-bold">
                  Invoice Generator
                </h3>
    
                {/* <!-- Text --> */}
                <p className="text-muted mb-8 mb-md-0">
                  Customize our invoice generator to your business’ sales process. Create professional
invoices that enhance your brand experience and value.
                </p>
    
              </div>
              <div className="col-12 col-md-6 col-lg-4 text-center" data-aos="fade-up">
    
                {/* <!-- Icon --> */}
                <div className="icon icon-lg mb-4"><HourglassFullTwoToneIcon /></div>
    
                {/* <!-- Heading --> */}
                <h3 className="fw-bold">
                  Scheduling
                </h3>
    
                {/* <!-- Text --> */}
                <p className="text-muted mb-8">
                  Online hourly work appointment scheduling applications that sync with your business timesheets approvals.
                </p>
    
              </div>
              <div className="col-12 col-md-6 col-lg-4 text-center" data-aos="fade-up">
    
                {/* <!-- Icon --> */}
                <div className="icon icon-lg mb-4"><SchoolTwoToneIcon /></div>
    
                {/* <!-- Heading --> */}
                <h3 className="fw-bold">
                  Learning Management
                </h3>
    
                {/* <!-- Text --> */}
                <p className="text-muted mb-8">
                  Enterprise graded lunch & learn application. Manage students, talents & resources online.
                </p>
    
              </div>
              <div className="col-12 col-md-6 col-lg-4 text-center" data-aos="fade-up">
    
                {/* <!-- Icon --> */}
                <div className="icon icon-lg mb-4"><AssessmentTwoToneIcon /></div>
    
                {/* <!-- Heading --> */}
                <h3 className="fw-bold">
                  Online Assessment
                </h3>
    
                {/* <!-- Text --> */}
                <p className="text-muted mb-8">
                  Multi functional time-based assessment tool for new hire or existing workers. Gamify learning System. 
                </p>
    
              </div>
              <div className="col-12 col-md-6 col-lg-4 text-center" data-aos="fade-up">
    
                {/* <!-- Icon --> */}
                <div className="icon icon-lg mb-4"><ContactPhoneTwoToneIcon /></div>
    
                {/* <!-- Heading --> */}
                <h3 className="fw-bold">
                  SalesBook
                </h3>
    
                {/* <!-- Text --> */}
                <p className="text-muted mb-8">
                  Capture Leads in realtime. Manage all your business Leads, Contacts & Accounts within the same app. 
                </p>
    
              </div>
              <div className="col-12 col-md-6 col-lg-4 text-center" data-aos="fade-up">
    
                {/* <!-- Icon --> */}
                <div className="icon icon-lg mb-4"><AssignmentTwoToneIcon /></div>
    
                {/* <!-- Heading --> */}
                <h3 className="fw-bold">
                  Task Manager
                </h3>
    
                {/* <!-- Text --> */}
                <p className="text-muted mb-8 mb-lg-0">
                  Create an Agile Board with a click. Manage resources, work estimates and organize your most important tasks.
                </p>
    
              </div>
              <div className="col-12 col-md-6 col-lg-4 text-center" data-aos="fade-up">
    
                {/* <!-- Icon --> */}
                <div className="icon icon-lg mb-4"><EventAvailableTwoToneIcon /></div>
    
                {/* <!-- Heading --> */}
                <h3 className="fw-bold">
                  Availability
                </h3>
    
                {/* <!-- Text --> */}
                <p className="text-muted mb-8 mb-md-0">
                  Track employees availability in realtime. Communicate opening and schedules in real time. No paper. No spreadsheets.
                </p>
    
              </div>
              <div className="col-12 col-md-6 col-lg-4 text-center" data-aos="fade-up">
    
                {/* <!-- Icon --> */}
                <div className="icon icon-lg mb-4"><ScheduleTwoToneIcon /></div>
    
                {/* <!-- Heading --> */}
                <h3 className="fw-bold">
                  Timesheet
                </h3>
    
                {/* <!-- Text --> */}
                <p className="text-muted mb-8">
                  A simple app that track hours, breaks, and overtime in real time. Validate timesheet based on project completed.
                </p>
    
              </div>
              <div className="col-12 col-md-6 col-lg-4 text-center" data-aos="fade-up">
    
                {/* <!-- Icon --> */}
                <div className="icon icon-lg mb-4"><LocalBarTwoToneIcon /></div>
    
                {/* <!-- Heading --> */}
                <h3 className="fw-bold">
                  Leave Management
                </h3>
    
                {/* <!-- Text --> */}
                <p className="text-muted mb-8">
                  Manage your workers availability and planned leave. See an overview of who is working in a simple dashbord.
                </p>
    
              </div>
              <div className="col-12 col-md-6 col-lg-4 text-center" data-aos="fade-up">
    
                {/* <!-- Icon --> */}
                <div className="icon icon-lg mb-4"><DateRangeTwoToneIcon /></div>
    
                {/* <!-- Heading --> */}
                <h3 className="fw-bold">
                  Event Management
                </h3>
    
                {/* <!-- Text --> */}
                <p className="text-muted mb-0">
                  Keep your entire team in sync with in-house and external events. Easily manage tickets and attendance.
                </p>
    
              </div>
            </div> {/* <!-- / .row --> */}
          </div> {/* <!-- / .container --> */}
        </section>
    
        {/* <!-- TESTIMONIALS --> */}
        <section className="pt-10 pt-md-12">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 col-md-10 col-lg-8 text-center">

                {/* <!-- Heading --> */}
                <h2>
                 Convenience. Security. Productivity.
                </h2>
 
                {/* <!-- Text --> */}
                <p className="fs-lg text-muted mb-7 mb-md-9">
                  There’s more than one reason why small business owners should choose us. We work for our customers. If you cannot
                  find an App you need, we will develop it for you.
                </p>

              </div>
            </div> {/* <!-- / .row --> */}
            <div className="row">
              <div className="col-12">

                {/* <!-- Card --> */}
                <div className="card card-row shadow-light-lg mb-6">
                  <div className="row gx-0">
                    <div className="col-12 col-md-6">

                      {/* <!-- Slider --> */}
                      <div className="card-img-slider" data-flickity='{"fade": true, "imagesLoaded": true, "pageDots": false, "prevNextButtons": false, "asNavFor": "#blogSlider", "draggable": false}'>
                        <a className="card-img-start w-100 bg-cover" style={{backgroundImage: "url(assets/img/photos/testimonial1.png)"}} href="#!">

                          {/* <!-- Image (placeholder) --> */}
                          <img src="assets/img/photos/photo-1.jpg" alt="..." className="img-fluid d-md-none invisible" />

                        </a>
                        <a className="card-img-start w-100 bg-cover" style={{backgroundImage: "url(assets/img/photos/photo-26.jpg)"}} href="#!">

                          {/* <!-- Image (placeholder) --> */}
                          <img src="assets/img/photos/photo-26.jpg" alt="..." className="img-fluid d-md-none invisible" />

                        </a>
                      </div>

                      {/* <!-- Shape --> */}
                      <div className="shape shape-end shape-fluid-y text-white d-none d-md-block">
                        <svg viewBox="0 0 112 690" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M116 0H51v172C76 384 0 517 0 517v173h116V0z" fill="currentColor"/></svg>                  </div>

                    </div>
                    <div className="col-12 col-md-6 position-md-static">

                      {/* <!-- Slider --> */}
                      <div className="position-md-static" data-flickity='{"wrapAround": true, "pageDots": false, "adaptiveHeight": true}' id="blogSlider">
                        <div className="w-100">

                          {/* <!-- Body --> */}
                          <div className="card-body">
                            <blockquote className="blockquote text-center mb-0">

                              {/* <!-- Brand --> */}
                              <div className="row justify-content-center mb-5 mb-md-7">
                                <div className="col-10">

                                  {/* <!-- Logo --> */}
                                  <div className="img-fluid" style={{color: "#FF5A5F"}}>
                                    <img src="assets/img/blackforce-logo2.png" alt=""/>
                                  </div>

                                </div>
                              </div> {/* <!-- / .row --> */}

                              {/* <!-- Text --> */}
                              <p className="mb-5 mb-md-7">
                                “SingleLogin accelerated the rapid development of the customer facing learning platform for the Blackforce Project.”
                              </p>

                              {/* <!-- Footer --> */}
                              <footer className="blockquote-footer">
                                <span className="h6 text-uppercase">Babatope Olajide<br/>Founder, Blackforce</span>
                              </footer>

                            </blockquote>
                          </div>

                        </div>
                        <div className="w-100">

                          {/* <!-- Body --> */}
                          <div className="card-body">
                            <blockquote className="blockquote text-center mb-0">

                              {/* <!-- Brand --> */}
                              <div className="row justify-content-center mb-5 mb-md-7">
                                <div className="col-6 col-sm-4 col-md-7 col-lg-5">

                                  {/* <!-- Logo --> */}
                                  <div className="img-fluid" style={{color: "#3F5D87"}}>
                                    <svg viewBox="0 0 2761 991" xmlns="http://www.w3.org/2000/svg"><path d="M273.497 198.251c-22.863 0-52.502 24.245-69.987 40.383-38.441 34.122-73.259 96.865-73.259 147.225 0 71.56 60.859 98.571 76.252 98.571 5.075 0 9.401-2.617 9.401-9.504 0-5.398-3.423-9.89-6.829-14.505-14.094-21.546-18.621-42.11-18.621-69.845 0-57.825 26.67-110.828 48.791-135.082 4.08-4.39 13.296-13.872 16.054-13.872 2.738 0 3.416 2.23 3.416 9.122l-2.57 378.481c0 59.167-17.072 82.67-17.072 96.602 0 6.121 2.65 7.71 7.71 7.71 23.959 0 47.835-29.202 54.6-39.852 20.976-36.232 26.12-64.515 26.12-146.097V229.55c0-8.609-2.414-12.33-10.592-17.638-11.96-7.595-25.664-13.66-43.414-13.66zm685.043 1.056c-11.268 0-16.086 5.891-16.619 24.12l-2.5 75.475-66.008-2.287c-4.004-.103-5.814 1.163-7.565 4.682-5.606 10.51-8.556 18.746-8.556 32.46 0 11.166 5.062 12.357 9.577 12.357l68.678 1.972-.21 144.197c0 30.583-19.3 70.258-53.543 103.256 0 0 2.945-9.963 2.777-20.415 0-29.588-19.041-56.4-44.427-75.373l-61.96-46.612c12.989-15.025 34.993-44.825 34.993-69.988 0-19.51-12.267-27.705-35.135-27.705-32.275 0-69.705 29.56-69.705 73.401 0 15.981 7.11 30.365 17.918 41.366-14.922 28.314-36.036 65.566-51.714 92.095-11.842 20.313-31.874 51.434-43.726 51.434-8.739 0-12.778-13.749-12.778-66.571 0-43.887 3.118-91.602 4.682-137.403 0-10.498-1.722-20.183-15.35-29.677-12.538-8.033-28.02-19.252-43.97-19.252-35.455 0-59.609 32.625-76.178 64.527-17.147 33.063-26.419 60.926-39.5 101.352l1.444-139.127c.446-9.92-2.06-13.772-9.997-17.147-10.298-4.367-25.456-9.402-38.901-9.402-11.237 0-12.603 4.845-12.603 16.651l-1.512 166.94-.172 64.387c0 58.05 7.27 67.73 41.716 67.73 19.072 0 25.18-2.24 25.559-18.093.523-10.485 5.538-35.888 12.322-61.364 19.842-75.195 43.353-134.67 83.891-180 4.227-4.4 7.495-2.825 6.83 3.413 0 0-6.41 101.765-6.41 143.389 0 74.03 11.392 112.658 48.227 112.658 36.15 0 71.656-46.45 91.038-77.806l62.175-103.994c40.288 34.33 68.4 60.946 68.4 93.326 0 20.125-12.697 39.815-32.039 39.815-24.171 0-39.614-25.49-55.94-25.49-13.552 0-30.944 26.16-30.944 41.016 0 14.024 30.603 33.863 85.513 33.863 81.059 0 124.542-55.628 150.638-117.23 4.995 73.114 34.127 115.822 79.562 115.822 29.803 0 64.247-37.653 79.915-83.647 0 0 1.547 11.94 13.446 36.402 16.38 31.944 41.28 46.611 72.208 46.611 38.468 0 71.371-23.32 91.459-62.452 3.045 29.652 27.943 62.307 67.98 62.307 25.133 0 48.046-19.257 63.086-50.976 0 0 19.482 52.388 75.83 52.388 31.65 0 69.127-29.32 78.084-50.623l.986 30.98-83.606 77.1c-24.277 23.566-50.1 57.425-50.1 94.913 0 47.677 45.015 75.092 84.63 75.092 41.178 0 68.5-26.088 83.468-47.948 18.836-28.285 26.792-81.596 26.792-133.708l-1.867-78.361c56.349-61.94 100.45-147.553 120.083-208.129l42.772-1.126c8.286-.558 7.873 2.705 6.727 7.535-7.517 31.767-14.082 67.743-14.082 103.571 0 59.192 13.634 84.95 33.231 106.001 17.04 17.638 33.984 23.587 51.82 23.587 34.88 0 56.776-28.804 63.72-46.962 16.38 31.944 40.509 46.821 71.43 46.821 38.47 0 71.374-23.32 91.464-62.452 3.045 29.652 27.938 62.307 67.978 62.307 29.912 0 47.262-17.26 60.906-49.78.275 10.46.678 21.612.986 32.068.36 5.41 4.685 8.833 8.556 10.245 12.715 4.812 23.876 7.22 33.901 7.22 26.147 0 31.825-5.37 31.825-22.463 0-28.19.826-72.733 8.836-108.496 8.504-35.606 21.337-75.914 39.044-103.96 1.594-2.897 5.5-2.136 5.67 1.375 2.543 60.007 6.557 161.589 22.32 187.885 7.779 12.543 19.808 21.685 37.809 21.685 8.44 0 18.788-3.6 21.436-5.844 2.683-2.092 4.034-4.417 3.871-8.729 0-76.711 23.924-150.978 47.88-200.91.659-1.482 2.526-1.597 2.463.352l-1.336 55.273c0 90.78 6.544 148.133 51.89 175.706a59.42 59.42 0 0029.184 7.565c23.2 0 44.239-12.958 54.637-33.796 8.47-16.194 16.406-47.363 16.406-65.018 0-6.834.08-17.958-11.123-17.958-6.144 0-9.835 4.53-11.304 11.371-3.571 14.83-6.502 27.548-12.042 42.21-5.296 13.997-13.198 22.147-22.568 22.147-11.006 0-16.591-8.66-19.785-14.014-14.044-21.421-15.17-70.63-15.17-111.704l3.381-105.718c0-8.747-3.651-19.215-17.147-26.932-9.06-5.215-31.972-15.033-46.011-15.033-13.018 0-19.32 7.373-24.012 18.196-8.811 19.44-38.255 95.688-46.15 157.68-.284 1.634-2.32 1.98-2.463-.105-4.104-43.839-6.21-96.66-6.164-132.295 0-10.773-2.635-26.173-25.488-36.153-11.106-4.608-20.293-7.428-31.512-7.428-13.919 0-16.912 6.812-21.897 15.838-15.768 29.135-26.671 67.128-43.015 115.05l.248-109.66c0-5.127-3.143-11.848-12.147-13.658-22.325-5.13-32.668-7.46-41.47-7.46-6.408 0-9.93 5.108-9.93 10.63l-1.198 186.973c-4.32 22.888-21.82 77.52-46.647 77.52-20.378 0-29.887-20.646-29.887-106.947l3.698-140.258c0-8.859-5.815-12.58-14.291-16.331-12.12-4.815-21.762-6.727-34.08-6.727-15.46 0-20.765 7.4-17.637 25.175-16.995-22.993-33.984-35.7-64-35.7-60.26 0-105.682 72.485-105.682 177.82-.591 29.537 6.546 58.894 6.546 58.894-5.453 24.515-18.27 44.497-35.978 44.497-22.34 0-36.577-31.584-36.577-86.321 0-54.9 20.91-116.82 20.91-133.602 0-19.512-12.784-31.856-35.415-31.856-11.336 0-53.39 9.54-74.95 12.67 0 0 2.433-10.268 2.253-18.341 0-19.24-9.027-31.296-31.437-31.296-27.385 0-47.492 19.554-47.492 52.915 0 14.967 8.62 28.816 20.032 36.256-14.812 61.782-38.896 107.728-74.387 159.057l2.99-207.848c0-6.757-1.799-10.954-15.034-16.091-6.997-3.023-18.401-6.514-32.776-6.514-20.833 0-19.454 14.877-18.34 26.016-9.533-16.902-30.4-36.965-62.596-36.965-87.732 0-114.667 133.784-101.459 228.794 0 11.584-11.311 52.703-36.86 52.703-20.377 0-29.887-20.646-29.887-106.947l3.734-140.258c0-8.861-5.856-12.582-14.332-16.331-12.12-4.815-21.726-6.727-34.044-6.727-15.463 0-20.768 7.4-17.64 25.173-16.994-22.993-34.019-35.701-64.036-35.701-60.26 0-106.284 66.291-106.284 171.622 0 40.208-34.62 101.564-58.897 101.564-13.486 0-27.845-24.757-27.845-88.01.067-43.116 5.948-189.893 5.948-189.893l84.738-1.374c4.044-.038 6.386-4.457 7.885-7.18 3.891-7.895 5.773-13.153 5.773-22.6 0-8.523-1.706-11.637-12.637-12.252l-84.457-5.07 3.593-78.679c.253-4.967-2.745-8.206-8.168-10.63-16.349-6.394-36.399-12.578-49.097-12.58zm256.462 206.157c22.593 0 45.518 20.605 45.518 93.711 0 92.047-33.533 134.872-59.32 134.872-24.173 0-42.524-34.121-42.524-101.143 0-67.746 17.92-127.44 56.326-127.44zm813.642 0c22.593 0 45.518 20.605 45.518 93.711 0 92.047-33.533 134.872-59.32 134.872-24.173 0-42.527-34.121-42.527-101.143.003-67.746 17.923-127.44 56.329-127.44zm-516.059.423c29.484 0 42.528 30.39 42.528 89.309 0 88.831-26.407 139.41-58.476 139.41-20.473 0-44.015-33.617-42.773-99.735 0-42.275 13.783-128.984 58.721-128.984zm49.917 297.162v34.99c0 116.106-30.938 135.924-55.798 135.924-9.42 0-32.492-7.115-32.492-35.839 0-40.152 41.98-85.83 55.025-99.945l33.265-35.13z" fill="currentColor" fillRule="nonzero"/></svg>                              </div>

                                </div>
                              </div> {/* <!-- / .row --> */}

                              {/* <!-- Text --> */}
                              <p className="mb-5 mb-md-7">
                                “I've never used a theme as versatile and flexible as Landkit. It's my go to for building landing sites on almost any project.”
                              </p>

                              {/* <!-- Footer --> */}
                              <footer className="blockquote-footer">
                                <span className="h6 text-uppercase">Russ D'Sa</span>
                              </footer>

                            </blockquote>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div> {/* <!-- / .row --> */}
                </div>

              </div>
            </div> {/* <!-- / .row --> */}
          </div> {/* <!-- / .container --> */}
        </section>

        {/* <!-- SHAPE --> */}
        <div className="position-relative mt-n8">
          <div className="shape shape-bottom shape-fluid-x text-gray-200">
            <svg viewBox="0 0 2880 480" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M2160 0C1440 240 720 240 720 240H0v240h2880V0h-720z" fill="currentColor"/></svg>      </div>
        </div>

        {/* <!-- STATS --> */}
        <section className="pt-12 pt-md-13 bg-gray-200">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-12 col-md-5 col-lg-6 order-md-2">

                {/* <!-- Image --> */}
                <img src="assets/img/illustrations/illustration-8.png" alt="..." className="img-fluid mb-6 mb-md-0" />

              </div>
              <div className="col-12 col-md-7 col-lg-6 order-md-1">

                {/* <!-- Heading --> */}
                <h2>
                  Stay focused on your business. <br />
                  <span className="text-primary">Let us handle the design</span>.
                </h2>

                {/* <!-- Text --> */}
                <p className="fs-lg text-gray-700 mb-6">
                   Focus on your business while we handle the technology side of things. No more worrying about micro technology solutions, designing new pages, keeping your employees up to date. Let us do that for you with one single authentication and authorization tool built on a decentralized technology.
                </p>

                {/* <!-- Stats --> */}
                <div className="d-flex">
                  <div className="pe-5">
                    <h3 className="mb-0">
                      <span data-countup='{"startVal": 0}' data-to="100" data-aos data-aos-id="countup:in"></span>%
                    </h3>
                    <p className="text-gray-700 mb-0">
                      Satisfaction
                    </p>
                  </div>
                  <div className="border-start border-gray-300"></div>
                  <div className="px-5">
                    <h3 className="mb-0">
                      <span data-countup='{"startVal": 0}' data-to="24" data-aos data-aos-id="countup:in"></span>/
                      <span data-countup='{"startVal": 0}' data-to="7" data-aos data-aos-id="countup:in"></span>
                    </h3>
                    <p className="text-gray-700 mb-0">
                      Support
                    </p>
                  </div>
                  <div className="border-start border-gray-300"></div>
                  <div className="ps-5">
                    <h3 className="mb-0">
                      <span data-countup='{"startVal": 0}' data-to="10" data-aos data-aos-id="countup:in"></span>+
                    </h3>
                    <p className="text-gray-700 mb-0">
                      Customers
                    </p>
                  </div>
                </div>

              </div>
            </div> {/* <!-- / .row --> */}
          </div> {/* <!-- / .container --> */}
        </section>

        {/* <!-- PRICING --> */}
        <section className="pt-9 pt-md-12 bg-gray-200" id="pricing">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 col-md-10 col-lg-8 text-center">

                {/* <!-- Heading --> */}
                <h1>
                  Simple pricing for all.
                </h1>

                {/* <!-- Text --> */}
                <p className="lead text-gray-700">
                  Single Login provides you with everything you need to secure your applications and customer relationship data at an affordable price.
                </p>
                
                {/* <!-- Form --> */}
                <form className="d-flex align-items-center justify-content-center mb-7 mb-md-9">

                  {/* <!-- Label --> */}
                  <span className="text-muted">
                    Standard
                  </span>

                  {/* <!-- Switch --> */}
                  <div className="form-check form-switch mx-3">
                    <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault" onChange={changePrice} />
                  </div>

                  {/* <!-- Label --> */}
                  <span className="text-muted">
                    Premium
                  </span>

                </form>

              </div>
            </div> {/* <!-- / .row --> */}
            <div className="row align-items-center gx-0">
              <div className="col-12 col-md-6">

                {/* <!-- Card --> */}
                <div className="card rounded-lg shadow-lg mb-6 mb-md-0" style={{zIndex: "1"}} data-aos="fade-up">

                  {/* <!-- Body --> */}
                  <div className="card-body py-6 py-md-8">
                    <div className="row justify-content-center">
                      <div className="col-12 col-xl-9">

                        {/* <!-- Badge --> */}
                        <div className="text-center mb-5">
                          <span className="badge rounded-pill bg-primary-soft">
                            <span className="h6 fw-bold text-uppercase">Business</span>
                          </span>
                        </div>

                        {/* <!-- Price --> */}
                        <div className="d-flex justify-content-center">
                          <span className="h2 mb-0 mt-2">$</span>
                          <span className="price display-2 mb-0" data-annual="5" data-monthly="2.5">{annual ? 5 : 3}</span>
                          <span className="h2 align-self-end mb-1">{annual ? '/mo' : '/mo'}</span>
                        </div>

                        {/* <!-- Text --> */}
                        <p className="text-center text-muted mb-6 mb-md-8">
                          per user
                        </p>

                        {/* <!-- Features --> */}
                        <div className="d-flex">

                          {/* <!-- Check --> */}
                          <div className="badge badge-rounded-circle bg-primary-soft mt-1 me-4">
                            <i className="fe fe-check"></i>
                          </div>

                          {/* <!-- Text --> */}
                          <p>
                            All Standard Applications.
                          </p>

                        </div>
                                   {/* <!-- Features --> */}
                        <div className="d-flex">

                          {/* <!-- Check --> */}
                          <div className="badge badge-rounded-circle bg-primary-soft mt-1 me-4">
                            <i className="fe fe-check"></i>
                          </div>

                          {/* <!-- Text --> */}
                          <p>
                            {annual ? '4' : '0'} Premium Applications.
                          </p>

                        </div>
                        
                        <div className="d-flex">

                          {/* <!-- Check --> */}
                          <div className="badge badge-rounded-circle bg-primary-soft mt-1 me-4">
                            <i className="fe fe-check"></i>
                          </div>

                          {/* <!-- Text --> */}
                          <p>
                            Shared Server & Database.
                          </p>

                        </div>
                        <div className="d-flex">

                          {/* <!-- Check --> */}
                          <div className="badge badge-rounded-circle bg-primary-soft mt-1 me-4">
                            <i className="fe fe-check"></i>
                          </div>

                          {/* <!-- Text --> */}
                          <p>
                            Flexible, PAYG license
                          </p>

                        </div>
                        <div className="d-flex">

                          {/* <!-- Check --> */}
                          <div className="badge badge-rounded-circle bg-primary-soft mt-1 me-4">
                            <i className="fe fe-check"></i>
                          </div>

                          {/* <!-- Text --> */}
                          <p>
                            {annual ? '' : 'No'} Integration API access.
                          </p>

                        </div>
                        <div className="d-flex">

                          {/* <!-- Check --> */}
                          <div className="badge badge-rounded-circle bg-primary-soft mt-1 me-4">
                            <i className="fe fe-check"></i>
                          </div>

                          {/* <!-- Text --> */}
                          <p className="mb-0">
                            Free support & Upgrades.
                          </p>

                        </div>

                      </div>
                    </div> {/* <!-- / .row --> */}
                  </div>

                  {/* <!-- Button --> */}
                  <a href="/#demo" data-scroll='{"offset": 0}' className="card-btn btn w-100 btn-lg btn-primary">
                    Get it now
                  </a>

                </div>

              </div>
              <div className="col-12 col-md-6 ms-md-n3">

                {/* <!-- Card --> */}
                <div className="card rounded-lg shadow-lg" data-aos="fade-up" data-aos-delay="200">

                  {/* <!-- Body --> */}
                  <div className="card-body py-6 py-md-8">
                    <div className="row justify-content-center">
                      <div className="col-12 col-xl-10">

                        {/* <!-- Badge --> */}
                        <p className="text-center mb-8 mb-md-11">
                          <span className="badge rounded-pill bg-primary-soft">
                            <span className="h6 fw-bold text-uppercase">Enterprise</span>
                          </span>
                        </p>

                        {/* <!-- Text --> */}
                        <p className="lead text-center text-muted mb-0 mb-md-10">
                          We offer variable pricing with discounts for larger organizations. Get in touch with us and we’ll figure out something that works for everyone.
                        </p>

                      </div>
                    </div> {/* <!-- / .row --> */}
                  </div>

                  {/* <!-- Button --> */}
                  <a href="/#demo" data-scroll='{"offset": 0}' className="card-btn btn w-100 btn-lg btn-light bg-gray-300 text-gray-700">
                    Contact us
                  </a>

                </div>

              </div>
            </div> {/* <!-- / .row --> */}
          </div> {/* <!-- / .container --> */}
        </section>

        {/* <!-- SHAPE --> */}
        <div className="position-relative mt-n15">
          <div className="shape shape-bottom shape-fluid-x text-dark">
            <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z" fill="currentColor"/></svg>      </div>
        </div>

        {/* <!-- FAQ --> */}
        <section className="pt-15 bg-dark" id="faq">
          <div className="container pt-8 pt-md-11">
            <div className="row">
              <div className="col-12 col-md-6">

                {/* <!-- Item --> */}
                <div className="d-flex">

                  {/* <!-- Badge --> */}
                  <div className="badge badge-lg badge-rounded-circle bg-primary">
                    <span>?</span>
                  </div>

                  <div className="ms-5">

                    {/* <!-- Heading --> */}
                    <h4 className="text-white">
                      Can I use SingleLogin for my external clients?
                    </h4>

                    {/* <!-- Text --> */}
                    <p className="text-muted mb-6 mb-md-8">
Absolutely. The SingleLogin license allows you to build an application for personal or Business use or for a client. All you need is a User Licence to authorize your application or any user that requires access.                     </p>

                  </div>

                </div>

                {/* <!-- Item --> */}
                <div className="d-flex">

                  {/* <!-- Badge --> */}
                  <div className="badge badge-lg badge-rounded-circle bg-primary">
                    <span>?</span>
                  </div>

                  <div className="ms-5">

                    {/* <!-- Heading --> */}
                    <h4 className="text-white">
                      Do I get free updates?
                    </h4>

                    {/* <!-- Text --> */}
                    <p className="text-muted mb-6 mb-md-0">
                      Yes. We automatically update all our applications with each deployed update, and constantly add new applications, pages, and features to our server.
                    </p>

                  </div>

                </div>

              </div>
              <div className="col-12 col-md-6">

                {/* <!-- Item --> */}
                <div className="d-flex">

                  {/* <!-- Badge --> */}
                  <div className="badge badge-lg badge-rounded-circle bg-primary">
                    <span>?</span>
                  </div>

                  <div className="ms-5">

                    {/* <!-- Heading --> */}
                    <h4 className="text-white">
                      Is there a money back guarantee?
                    </h4>

                    {/* <!-- Text --> */}
                    <p className="text-muted mb-6 mb-md-8">
                      No! Our business is licence-driven. If you do not like our service, all you need to do is stop licence renewal or subscription. We have a 30 day free trial for all new businesses.
                    </p>

                  </div>

                </div>

                {/* <!-- Item --> */}
                <div className="d-flex">

                  {/* <!-- Badge --> */}
                  <div className="badge badge-lg badge-rounded-circle bg-primary">
                    <span>?</span>
                  </div>

                  <div className="ms-5">

                    {/* <!-- Heading --> */}
                    <h4 className="text-white">
                      Does it work with other programming languages?
                    </h4>

                    {/* <!-- Text --> */}
                    <p className="text-muted mb-6 mb-md-0">
                      Yes. SingleLogin is an authentication and authorization tool that provides a token after authentication. You can develop or integrate your application around this principle. If you want to enable deeper customization, you can integrate it into your assets pipeline or build processes.
                    </p>

                  </div>

                </div>

              </div>
            </div> {/* <!-- / .row --> */}
          </div> {/* <!-- / .container --> */}
        </section>

        {/* <!-- CTA --> */}
        <section className="py-8 py-md-11 bg-dark">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-10 col-lg-8 text-center" id="demo">

              {/* <!-- Badge --> */}
              <span className="badge rounded-pill bg-gray-700-soft mb-4">
                <span className="h6 fw-bold text-uppercase">Get started</span>
              </span>

              {/* <!-- Heading --> */}
              <h1 className="display-4 text-white">
                Save Time and Stay in Complete Control of your Business.
              </h1>

              {/* <!-- Text --> */}
              <p className="fs-lg text-muted mb-6 mb-md-8">
                Our App is fast, simple and ready for use.
              </p>

                    {/* <!-- Card --> */}
                    <div className="card card-border border-primary shadow-light-lg" data-jarallax-element="-40">
                      <div className="card-body">
                        <div className="row justify-content-center">
                          <div className="col-12 col-xl-11">
        
                            {/* <!-- Image --> */}
                            <div className="text-center">
                              <img src="assets/img/illustrations/illustration-1.png" alt="..." className="img-fluid mb-3" style={{width: "200px"}} />
                            </div>
        
                            {/* <!-- Heading --> */}
                            <h2 className="fw-bold text-center mb-1">
                              Schedule a demo with us
                            </h2>
        
                            {/* <!-- Text --> */}
                            <p className="fs-lg text-center text-muted mb-6 mb-md-8">
                              We can help you accelerate business productivity.
                            </p>
        
                            {/* <!-- Form --> */}
                            <Form />
        
                          </div>
                        </div> {/* <!-- / .row --> */}
                      </div>
                    </div>

            </div>
          </div> {/* <!-- / .row --> */}
        </div> {/* <!-- / .container --> */}
      </section>
      </>
    )
}